import USER_API from 'api/user/v1'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import { SET_APP_DATA } from 'modules/App/types'

function* getUserInfo() {
  try {
    yield put({
      type: 'USER/GET_USER_INFO_FETCH_START',
      payload: 'user/info',
    })

    const { response, error } = yield call(USER_API.fetchUser)

    if (error) {
      throw error
    }

    yield put({
      type: 'USER/SET_USER_INFO',
      payload: response,
    })
  } catch (error) {
    yield put({
      type: 'USER/GET_USER_INFO_FETCH_FAIL',
      payload: 'user/info',
    })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: 'USER/GET_USER_INFO_FETCH_END',
      payload: 'user/info',
    })
  }
}

function* updateUser({ payload }) {
  try {
    const { error } = yield call(USER_API.updateUser, { data: payload })

    if (error) {
      throw error
    }
  } catch (error) {
    console.logXHR(error)
  }
}

function* updateUserLocale({ payload }) {
  yield put({ type: SET_APP_DATA, payload: { i18n: payload.locale } })
  try {
    const { auth } = yield select((state) => state['auth'])

    if (auth) {
      const { error } = yield call(USER_API.updateUser, {
        data: payload,
      })

      if (error) {
        throw error
      }
    }
  } catch (error) {
    //yield put({ type: 'APP/SET_APP_DATA', payload: { i18n: payload.locale } })
    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest('USER/GET_USER_INFO', getUserInfo)
  yield takeLatest('USER/UPDATE_USER', updateUser)
  yield takeLatest('USER/UPDATE_USER_LOCALE', updateUserLocale)
}
